import { Box } from "@mui/material"
import { AdultTradeSetting, BeanShuffle, BigPoesSetting, BkSanitySetting, BlueFireArrowSetting, BombchusDropSetting, BossShuffleSetting, BoulderSetting, BridgeSetting, CowsanitySetting, DamageSetting, DekuSetting, DungeonShuffleSetting, EscapeSequence, ExpensiveMerchantsSetting, FortressSetting, FountainSetting, FreeEponaSetting, FreeScarecrowSetting, FrogSongShuffleSetting, GbkSetting, GerudoCardSetting, GrottoShuffleSetting, IceTrapSetting, InteriorShuffleSetting, ItemPoolSetting, KeyringSetting, KeysanitySetting, KsSetting, MapCompassInfoSetting, MaxRupeeSetting, MixPoolSetting, OcarinaNoteSetting, OcarinaSetting, OverworldShuffleSetting, OwlDropSetting, PotCrateFreestandingSetting, PrePlantedBean, RutoF1Setting, ScrubsanitySetting, ShopsanitySetting, ShortcutSetting, SilverRuppeSetting, SongSanitySettin, SoulsanitySetting, TokensanitySetting, TrialSetting, TriforceHuntSetting, WarpSongSetting } from "./SettingsData"
import { useEffect, useState } from "react"

import { SettingsTrackedDto } from "./RslDataType"
import ReworkItemTracker from "../tracker/ReworkitemTracker"
import ReworkChildSongTracker from "../tracker/ReworkChildSongTracker"
import ReworkWarpSongTracker from "../tracker/ReworkWarpSongTracker"
import ReworkOcarinaNoteTracker from "../tracker/ReworkOcarinaNoteTracker"
import ReworkDungeonTracker from "../tracker/ReworkDungeonTracker"
import RewardRewardTracker, { RewardDto, RewardEnum } from "../tracker/ReworkRewardTracker"
import ReworkSometimesTracker from "../tracker/ReworkSometimesTracker"
import ReworkPathTracker from "../tracker/ReworkPathTracker"
import AdditionalItemTracker from "../tracker/AdditionalItemTracker"
import ReworkTrialTracker, { TrialEnum } from "../tracker/ReworkTrialTracker"
import ReworkAdultTradeSequenceTracker from "../tracker/ReworkAdultTradeSequenceTracker"
import EntranceTracker from "../mixpool/EntranceTracker"
import { EnnemyDto, RegionalSoulObjectProps, RegionSoulEnum, SoulTracker } from "../ennemy/EnnemyTracker"
import ShopsanityTracker, { ShopDto } from "../shopsanity/ShopSanityTracker"
import CheckTracker, { CratesChecks, FreestandingChecks, PotsChecks } from "../tracker/PotTracker"
import BaseTabs from "../../core/components/base/BaseTabs"
import SettingsElements from "./s7/SetttingElements"
import PreventRefresh from "../../core/components/utils/PreventRefresh"
import { DefaultGoalHintDto, GoalHintDto } from "../hints/PathHintsTracker"
import { LocationAutocompleteDto } from "../locations/LocationDtos"
import { BossDto } from "../hints/BossAutocomplete"
import { OotItemDto } from "../hints/OotItemAutocomplete"
import { clone, cloneDeep, isNil, sortBy } from "lodash"
import { DefaultSometimeHint, SometimeHintProps } from "../hints/SometimesHint"
import { HintRandomizerDto } from "../hints/HintsAutocomplete"
import { DungeonDto, DungeonEnum, Dungeons } from "../dungeon/DungeonDto"
import { MedallionProps } from "../inventory/medallions/MedallionInterface"
import { UsefullEnnemySoul } from "../ennemy/EnnemySoulData"
import { ItemContextLabelizedDto } from "../hints/OotItemContextMenuButton"
import LightSphereTracker, { defaultLightSphereTracker } from "../sphere/LigthSphereTracker"



const S7SettingsTracker = () => {

    // Win con
    let [bridge, setBridge] = useState(-1)
    let [bridgeNumber, setBridgeNumber] = useState(0)
    let [gbk, setGbk] = useState(-1)
    let [gbkNumber, setGbkNumber] = useState(0)
    let [triforceHunt, setTriforceHunt] = useState(-1)

    //QoL
    let [epona, setEpona] = useState(-1)
    let [prePlanted, setPrePlanted] = useState(-1)
    let [itemPool, setItemPool] = useState(-1)
    let [rutoF1, setRutoF1] = useState(-1)

    let [scarecrow, setScarecrow] = useState(-1)
    let [damage, setDamage] = useState(-1)
    let [iceTrap, setIceTrap] = useState(-1)
    let [bombchus, setBombchus] = useState(-1)

    let [escape, setEscape] = useState(-1)
    let [bfa, setBfa] = useState(-1)
    let [maxRupee, setMaxRupee] = useState(-1)
    let [mapCompass, setMapCompass] = useState(-1)

    //World
    let [deku, setDeku] = useState(-1)
    let [fountain, setFountain] = useState(-1)
    let [fortress, setFotress] = useState(-1)
    let [trials, setTrials] = useState(-1)
    let [shortcut, setShortcut] = useState(-1)
    let [overworld, setOverworld] = useState(-1)
    let [interior, setInterior] = useState(-1)
    let [grotto, setGrotto] = useState(-1)
    let [dungeon, setDungeon] = useState(-1)
    let [boss, setBoss] = useState(-1)
    let [mixPool, setMixPool] = useState<Array<SettingsTrackedDto>>([])

    //sanity
    let [token, setToken] = useState(-1)
    let [shop, setShop] = useState(-1)
    let [scrub, setScrub] = useState(-1)
    let [cow, setCow] = useState(-1)
    let [song, setSong] = useState(-1)
    let [warp, setWarp] = useState(-1)
    let [owl, setOwl] = useState(-1)
    let [boulder, setBoulder] = useState(-1)
    let [silver, setSilver] = useState(-1)

    let [ocarina, setOcarina] = useState(-1)
    let [ocarinaNote, setOcarinaNote] = useState(-1)
    let [adultTrade, setAdultTrade] = useState(-1)
    let [keys, setKeys] = useState(-1)
    let [keyring, setKeyring] = useState(-1)
    let [bk, setBk] = useState(-1)
    let [frog, setFrog] = useState(-1)
    let [gerudoCard, setGerudoCard] = useState(-1)
    let [ks, setKs] = useState(-1)
    let [merchant, setMerchant] = useState(-1)
    let [beans, setBeans] = useState(-1)
    let [bigpoes, setBigPoes] = useState(-1)

    let [potCrateFreestanding, setPotCrateFreestanding] = useState(-1)
    let [soulsanity, setSoulsanity] = useState(-1)

    let [notes, setNotes] = useState<Array<string>>([])
    let [silverRupeesObtained, setSilverRupeesObtained] = useState<Array<string>>([])

    let [message, setMessage] = useState("")

    let [goalHints, setGoalHints] = useState<Array<GoalHintDto>>([clone(DefaultGoalHintDto),clone(DefaultGoalHintDto),clone(DefaultGoalHintDto),clone(DefaultGoalHintDto),clone(DefaultGoalHintDto)])

    let [sometimes, setSometimes] = useState<Array<SometimeHintProps>>([...Array(21)].map(i => DefaultSometimeHint));

    let [shops, setShops] = useState<Array<ShopDto>>([
        {id:1, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:2, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:3, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:4, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:5, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:6, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:7, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
        {id:8, name: null, shopItems: [{index: 0, item: null, price: "0" },{index: 1, item: null, price: "0" },{index: 2, item: null, price: "0" },{index: 3, item: null, price: "0" }]},
    ])

    const setShopItem = (id: number, name: string |null, index: number, item: OotItemDto | null, price: string) => {
        
       let shop = cloneDeep(shops.find(x => x.id === id))

       if(isNil(shop))
        return;

       shop.name = name;
       shop.shopItems[index].item = item;
       shop.shopItems[index].price = price;

       console.log(shop, id, name, index, item, price)
       setShops(sortBy([...shops.filter(x => x.id !== id), shop], "id"))
    }

    let [ennemiesSoul, setEnnemiesSoul] = useState<Array<EnnemyDto>>(sortBy(UsefullEnnemySoul, ["type","order","name"], ["desc", "asc","asc"]))

    const setEnnemySoul = (ennemy: EnnemyDto) => {
        setEnnemiesSoul(sortBy([...ennemiesSoul.filter(x => x.name !== ennemy.name), ennemy],  ["type","order","name"], ["desc", "asc","asc"]))
    }

    let [regionalEnnemies, setRegionalEnnemies] = useState<Array<RegionalSoulObjectProps>>([
        {region: RegionSoulEnum.Deku},
        {region: RegionSoulEnum.DC},
        {region: RegionSoulEnum.Jabu},
        {region: RegionSoulEnum.Forest},
        {region: RegionSoulEnum.Fire},
        {region: RegionSoulEnum.Water},
        {region: RegionSoulEnum.Shadow},
        {region: RegionSoulEnum.Spirit},
        {region: RegionSoulEnum.Ganon},
        {region: RegionSoulEnum.Botw},
        {region: RegionSoulEnum.Ice},
        {region: RegionSoulEnum.Gtg},
        {region: RegionSoulEnum.SFM},
        {region: RegionSoulEnum.Grottos},
    ])

    const setRegionalEnnemy = (r: RegionSoulEnum, value: RegionalSoulObjectProps) => {

        setRegionalEnnemies([...regionalEnnemies.filter(x => x.region !== r), value])
    }
    
    let [rewards, setRewards] = useState<Array<RewardDto>>([
        {id: RewardEnum.KokiriEmerald, settings: {isObtained: false, indexLabel: 0}}
    ])

    const setReward = (r: RewardEnum, props: MedallionProps) => {

        setRewards([...rewards.filter(x => x.id !== r), {id: r, settings: props}])
    }
    //dungeons

    let [dungeons, setDungeons] = useState<Array<DungeonDto>>([...Dungeons])

    const setDungeonValue = (value: DungeonDto, dungeon: DungeonEnum) => {
        setDungeons([...dungeons.filter(x => x.id !== dungeon), value]);
    }

    //Sphere tracking
    let [sphereItems, setSphereItems] = useState<Array<Array<ItemContextLabelizedDto>>>(defaultLightSphereTracker)

    const setSphereItem = (item: ItemContextLabelizedDto, indexItem: number, sphereIndex: number) => {

        let items = cloneDeep(sphereItems);

        items[sphereIndex][indexItem] = item;

        setSphereItems(items);
    }
    //trials

    let [forestActivated, setForestActivated] = useState<boolean>(false)
    let [fireActivated, setFireActivated] = useState<boolean>(false)
    let [waterActivated, setWaterActivated] = useState<boolean>(false)
    let [shadowActivated, setShadowActivated] = useState<boolean>(false)
    let [spiritActivated, setSpiritActivated] = useState<boolean>(false)
    let [lightActivated, setLightActivated] = useState<boolean>(false)


    const setTrialActivated = (trial: TrialEnum, value: boolean) => {
        switch (trial) {
            case TrialEnum.Forest:
                setForestActivated(value);
                break;
            case TrialEnum.Fire:
                setFireActivated(value);
                break;
            case TrialEnum.Water:
                setWaterActivated(value);
                break;
            case TrialEnum.Shadow:
                setShadowActivated(value);
                break;
            case TrialEnum.Spirit:
                setSpiritActivated(value);
                break;
            case TrialEnum.Light:
                setLightActivated(value);
                break;
            default:
                break;
        }

    }


    const setSometimesState = (state: number, index: number) => {
        if(index === sometimes.length -1)
            setSometimes([...sometimes.slice(0,index), {...sometimes[index], state: state}])
        else if(index === 0)
            setSometimes([{...sometimes[index], state: state}, ...sometimes.slice(index+1,sometimes.length) ])
        else
            setSometimes([...sometimes.slice(0,index), {...sometimes[index], state: state}, ...sometimes.slice(index+1,sometimes.length)])
    }

    const setSometimesHint = (hint: HintRandomizerDto | null, index: number) => {
        if(index === sometimes.length -1)
            setSometimes([...sometimes.slice(0,index), {...sometimes[index], hint: hint}])
        else if(index === 0)
            setSometimes([{...sometimes[index], hint: hint}, ...sometimes.slice(index+1,sometimes.length) ])
        else
            setSometimes([...sometimes.slice(0,index), {...sometimes[index], hint: hint}, ...sometimes.slice(index+1,sometimes.length)])
    }

    const setSometimesItem = (v: OotItemDto | null, index: number, indexItem: number) => {


        let itemToReplace = clone(sometimes[index])
        if(indexItem === 1)
            itemToReplace.hintItem1 = v;
        else if (indexItem === 2)
            itemToReplace.hintItem2 = v;

        let items = cloneDeep(sometimes);
        items[index] = itemToReplace;

        setSometimes(items);

  
    }


    const setGoalHintLocation = (v: LocationAutocompleteDto | null, i: number) => {


        if(i === goalHints.length -1)
            setGoalHints([...goalHints.slice(0,i), {goal: goalHints[i].goal, location: v, items: goalHints[i].items}])
        else if(i === 0)
            setGoalHints([{goal: goalHints[i].goal, location: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
        else
            setGoalHints([...goalHints.slice(0,i), {goal: goalHints[i].goal, location: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])

    }

    const setGoalHintGoal = (v: BossDto | null, i: number) => {
        if(i === goalHints.length -1)
            setGoalHints([...goalHints.slice(0,i), {location: goalHints[i].location, goal: v, items: goalHints[i].items}])
        else if(i === 0)
            setGoalHints([{location: goalHints[i].location, goal: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])
        else
            setGoalHints([...goalHints.slice(0,i), {location: goalHints[i].location, goal: v, items: goalHints[i].items}, ...goalHints.slice(i+1,goalHints.length) ])

    }

    const setGoalHintItems = (v: OotItemDto | null, index: number, indexItem: number) => {

        let items = clone([...goalHints[index].items]);
        items[indexItem] =  v;
        

        let goals = cloneDeep([...goalHints]);

        console.log(goals);
        goals[index].items = items;

        setGoalHints(goals);

  
    }






    useEffect(() => {

        let newMessage = "";
        if(bridge >= 0){
            newMessage += "Bridge : "
            if(bridgeNumber > 0)
                newMessage += bridgeNumber + " "
            newMessage += BridgeSetting.states[bridge].name + " -- "
        }

        if(gbk >= 0){
            newMessage += "GBK : "
            if(gbkNumber > 0)
                newMessage += gbkNumber + " "
            newMessage += GbkSetting.states[gbk].name + " -- "
        }

        if(triforceHunt >= 0){
            newMessage += "TriforceHunt : "
            newMessage += TriforceHuntSetting.states[triforceHunt].name  + " -- "
        }

        if(token >= 0){
            newMessage += "Token : "
            newMessage += TokensanitySetting.states[token].name  + " -- "
        }
        if(shop >= 0){
            newMessage += "Shop : "
            newMessage += ShopsanitySetting.states[shop].name  + " -- "
        }
        if(scrub >= 0){
            newMessage += "Scrub : "
            newMessage += ScrubsanitySetting.states[scrub].name  + " -- "
        }

        if(newMessage !== message)
            setMessage(newMessage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bridge, bridgeNumber, gbk, gbkNumber])





    return <Box position="absolute" top={80} left={80} >

        <PreventRefresh />

        <BaseTabs tabItems={[
            {label: "Settings", disabled: false},
            {label: "Tracker", disabled: false},
            {label: "Entrances", disabled: false},
        ]}
            tabPanels={[
                <SettingsElements
                    settings={
                        {
                            "Bridge": {setting: BridgeSetting, width: 200, index: bridge, setIndex: setBridge, subValue: bridgeNumber, setSubValue: setBridgeNumber, displayField: true, indexesDisplayField: [2,3,4,5,6,7], widthSettingName: 80, top: 45, left: 45},
                            "Gbk": {setting: GbkSetting, width: 200, index: gbk, setIndex: setGbk, subValue: gbkNumber, setSubValue: setGbkNumber, displayField: true, indexesDisplayField: [8,9,10,11,12], widthSettingName: 110, top: 45, left:280},
                            "TriforceHunt": {setting: TriforceHuntSetting, width: 200, index: triforceHunt, setIndex: setTriforceHunt, displayField: true, indexesDisplayField: [2,3,4,5,6,7], widthSettingName: 50, top: 75, left: 175},

                            "Epona": {setting: FreeEponaSetting, index: epona, setIndex: setEpona, width: 200},
                            "PlantedBean": {setting: PrePlantedBean, index: prePlanted, setIndex: setPrePlanted, width: 200},
                            "ItemPool": {setting: ItemPoolSetting, index: itemPool, setIndex: setItemPool, width: 200},
                            "RutoF1": {setting: RutoF1Setting, index: rutoF1, setIndex: setRutoF1, width: 200},

                            "FreeScarecrow": {setting: FreeScarecrowSetting, index: scarecrow, setIndex: setScarecrow, width: 200},
                            "Damage": {setting: DamageSetting, index: damage, setIndex: setDamage, width: 200},
                            "IceTrap": {setting: IceTrapSetting, index: iceTrap, setIndex: setIceTrap, width: 200},
                            "Bombchus": {setting: BombchusDropSetting, index: bombchus, setIndex: setBombchus, width: 200},

                            "Escape": {setting: EscapeSequence, index: escape, setIndex: setEscape, width: 200},
                            "BFA": {setting: BlueFireArrowSetting, index: bfa, setIndex: setBfa, width: 200},
                            "MaxRupee": {setting: MaxRupeeSetting, index: maxRupee, setIndex: setMaxRupee, width: 200},
                            "MapCompass": {setting: MapCompassInfoSetting, index: mapCompass, setIndex: setMapCompass, width: 200},

                            "Deku": {setting: DekuSetting, index: deku, setIndex: setDeku, width: 200},
                            "Fountain": {setting: FountainSetting, index: fountain, setIndex: setFountain, width: 200},
                            "Fortress": {setting: FortressSetting, index: fortress, setIndex: setFotress, width: 200},
                            "Trials": {setting: TrialSetting, index: trials, setIndex: setTrials, width: 200},
                            "Shortcut": {setting: ShortcutSetting, index: shortcut, setIndex: setShortcut, width: 200},

                            "OverworldEr": {setting: OverworldShuffleSetting, index: overworld, setIndex: setOverworld, width: 200},
                            "InterriorEr": {setting: InteriorShuffleSetting, index: interior, setIndex: setInterior, width: 200},
                            "GrottoEr": {setting: GrottoShuffleSetting, index: grotto, setIndex: setGrotto, width: 200},
                            "DungeonEr": {setting: DungeonShuffleSetting, index: dungeon, setIndex: setDungeon, width: 200},
                            "BossEr": {setting: BossShuffleSetting, index: boss, setIndex: setBoss, width: 200},
                            "Mixpool": {setting: MixPoolSetting, options: mixPool, setOptions: setMixPool, width: 200},

                            "Token": {setting: TokensanitySetting, index: token, setIndex: setToken, width: 200},
                            "Shop": {setting: ShopsanitySetting, index: shop, setIndex: setShop, width: 200},
                            "Scrub": {setting: ScrubsanitySetting, index: scrub, setIndex: setScrub, width: 200},
                            "Cow": {setting: CowsanitySetting, index: cow, setIndex: setCow, width: 200},
                            "Song": {setting: SongSanitySettin, index: song, setIndex: setSong, width: 200},
                            "Warp": {setting: WarpSongSetting, index: warp, setIndex: setWarp, width: 200},
                            "Owl": {setting: OwlDropSetting, index: owl, setIndex: setOwl, width: 200},

                            "Ocarina": {setting: OcarinaSetting, index: ocarina, setIndex: setOcarina, width: 200},
                            "OcarinaNote": {setting: OcarinaNoteSetting, index: ocarinaNote, setIndex: setOcarinaNote, width: 200},
                            "AdultTrade": {setting: AdultTradeSetting, index: adultTrade, setIndex: setAdultTrade, width: 200},
                            "Keys": {setting: KeysanitySetting, index: keys, setIndex: setKeys, width: 200},
                            "Bks": {setting: BkSanitySetting, index: bk, setIndex: setBk, width: 200},
                            "GerudoCard": {setting: GerudoCardSetting, index: gerudoCard, setIndex: setGerudoCard, width: 200},
                            "Keyrings": {setting: KeyringSetting, index: keyring, setIndex: setKeyring, width: 200},

                            "KS": {setting: KsSetting, index: ks, setIndex: setKs, width: 200},
                            "ExpensiveMerchants": {setting: ExpensiveMerchantsSetting, index: merchant, setIndex: setMerchant, width: 200},
                            "Beans": {setting: BeanShuffle, index: beans, setIndex: setBeans, width: 200},
                            "BigPoes": {setting: BigPoesSetting, index: bigpoes, setIndex: setBigPoes, width: 200},
                            "Boulders": {setting: BoulderSetting, index: boulder, setIndex: setBoulder, width: 200},
                            "Silvers": {setting: SilverRuppeSetting, index: silver, setIndex: setSilver, width: 200},
                            "FrogSongs": {setting: FrogSongShuffleSetting, index: frog, setIndex: setFrog, width: 200},
                            "Souls": {setting: SoulsanitySetting, index: soulsanity, setIndex: setSoulsanity, width: 200},
                            "PotCrate": {setting: PotCrateFreestandingSetting, index: potCrateFreestanding, setIndex: setPotCrateFreestanding, width: 200},

                        }
                    }

                />,
                <>

        <ReworkItemTracker top={50} left={0} />

        <Box display={"flex"} flexDirection={warp !== 0 ? "column" : "row"} position={"absolute"} top={260} left={10} width={250} height={300}>
            <ReworkChildSongTracker  a={notes.some(x => x === "a") || ocarinaNote !== 0} cdown={notes.some(x => x === "cdown") || ocarinaNote !== 0} cleft={notes.some(x => x === "cleft") || ocarinaNote !== 0} cright={notes.some(x => x === "cright") || ocarinaNote !== 0} cup={notes.some(x => x === "cup") || ocarinaNote !== 0} display={warp === 0 ? "vertical" : "horizontal"} />
            <ReworkWarpSongTracker warpShuffle={warp === 0}  a={notes.some(x => x === "a") || ocarinaNote !== 0} cdown={notes.some(x => x === "cdown") || ocarinaNote !== 0} cleft={notes.some(x => x === "cleft" || ocarinaNote !== 0) || ocarinaNote !== 0} cright={notes.some(x => x === "cright") || ocarinaNote !== 0} cup={notes.some(x => x === "cup") || ocarinaNote !== 0} display={warp === 0 ? "vertical" : "horizontal"} />

        </Box>

        <ReworkDungeonTracker
            top={50}
            left={500}
            bkShuffle={bk > 0}
            keyShuffle={keys > 0}
            bossShuffle={boss === 0}
            dungeonShuffle={dungeon > 0 && (!mixPool.some(x => x.name === "Dungeon") || mixPool.length <= 1) }
            keyring={keyring === 0}
            silverRupee={silver > 1}
            setSilverRupeesObtained={setSilverRupeesObtained}
            silverRupeesObtained={silverRupeesObtained}
            dungeons={dungeons}
            setDungeonValue={setDungeonValue}

        />
        <RewardRewardTracker
            top={50}
            left={200}
            rewards={rewards}
            setReward={setReward}

        />
        <Box display={"flex"} flexDirection={"column"} position={"absolute"} top={200} left={210} width={225}>
            <AdditionalItemTracker gerudoCardShuffle={gerudoCard === 0} openFountain={fountain === 0} adultTradeSequenceOnlyOne={adultTrade !== 0}/>
            <ReworkTrialTracker trialActivated={trials > 0} 
                                setTrial={setTrialActivated} 
                                forestActivated={forestActivated}
                                fireActivated={fireActivated}
                                waterActivated={waterActivated}
                                shadowActivated={shadowActivated}
                                spiritActivated={spiritActivated}
                                lightActivated={lightActivated}
            />
            <ReworkAdultTradeSequenceTracker isShuffle={adultTrade !== 0} />
            <ReworkOcarinaNoteTracker noteShuffle={ocarinaNote === 0}
            setNotes={(v: string) => {
                if(notes.some(x => x === v))
                    setNotes([...notes.filter(x => x !== v)])
                else
                    setNotes([...notes, v])
        }}
        notes={notes}/>
        </Box>
            <ReworkPathTracker top={500} left={0} goalHints={goalHints} setGoal={setGoalHintGoal} setLocation={setGoalHintLocation} setItem={setGoalHintItems} />
        <Box>
            <ReworkSometimesTracker top={730} left={10} hints={sometimes} setHint={setSometimesHint} setState={setSometimesState} setItems={setSometimesItem} />
        </Box>
        <Box position="absolute" top={0} left={1500}>
            <LightSphereTracker spheres={sphereItems} setSphereItem={setSphereItem} />
        </Box>
        <Box position={"absolute"} top={50} left={1050} display={"flex"} flexDirection={"column"}>
            <SoulTracker 
                regionalEnnemies={regionalEnnemies}
                setRegionalEnnemy={setRegionalEnnemy}
                setEnnemy={setEnnemySoul}
                ennemies={ennemiesSoul}
                track={soulsanity === 1 ? "boss" : soulsanity === 2 ? "regional" : soulsanity === 3 ? "all" : undefined }/>
            {shop > 1 && <ShopsanityTracker setShopItem={setShopItem} shops={shops} />}
            {potCrateFreestanding === 1 && <CheckTracker checks={PotsChecks} />}
            {potCrateFreestanding === 2 && <CheckTracker checks={CratesChecks} />}
            {potCrateFreestanding === 3 && <CheckTracker checks={FreestandingChecks} />}
        </Box> 
                </>,
                <EntranceTracker
                dungeons={mixPool.some(x => x.name === "Dungeon") && mixPool.length > 1}
                grottos={grotto === 0 || mixPool.some(x => x.name === "Grotto")}
                interrior={interior > 0 || mixPool.some(x => x.name === "Interior")}
                overworld={overworld === 0 || mixPool.some(x => x.name === "Overworld")}
                displayImportantInterrior
                />
            ]
            
        }

        />


    </Box>
}

export default S7SettingsTracker






